import React, { useState, useEffect } from 'react';
import { FaTimes, FaCrown, FaGem, FaStar, FaTrophy } from 'react-icons/fa';

const RenewSubscription = ({ isOpen, onClose }) => {
  const [mounted, setMounted] = useState(false);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setMounted(true);
      setTimeout(() => setActive(true), 10);
    } else {
      setActive(false);
      setTimeout(() => setMounted(false), 300);
    }
  }, [isOpen]);

  const handlePackageSelect = (packageType) => {
    console.log(`Selected package: ${packageType}`);
    // اینجا می‌توانید API call برای خرید بسته اضافه کنید
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!mounted) return null;

  return (
    <div 
      className={`fixed inset-0 bg-black/50 z-50 transition-opacity duration-300 ${
        active ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={handleBackdropClick}
    >
      <div 
        className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl transform transition-transform duration-300 max-h-[85vh] flex flex-col ${
          active ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100">
          <h3 className="text-xl font-bold text-gray-900">Renew Subscription</h3>
          <button 
            onClick={onClose}
            className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
          >
            <FaTimes className="text-gray-600" />
          </button>
        </div>
        
        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6 space-y-4">
          {/* 1 Month Package */}
          <div className="bg-gradient-to-r from-primary/10 to-blue-100 rounded-2xl p-5 border border-primary/20">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center ml-3">
                  <FaCrown className="text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">1-Month Package</h4>
                  <p className="text-sm text-gray-600">Most Popular Choice</p>
                </div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-primary">100,000</div>
                <div className="text-sm text-gray-500">USDT</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="bg-white/60 rounded-xl p-3 text-center">
                <div className="text-lg font-bold text-gray-900">10</div>
                <div className="text-xs text-gray-600">Daily Alerts</div>
              </div>
              <div className="bg-white/60 rounded-xl p-3 text-center">
                <div className="text-lg font-bold text-gray-900">300</div>
                <div className="text-xs text-gray-600">Monthly Alerts</div>
              </div>
            </div>
            <button 
              onClick={() => handlePackageSelect('1-month')}
              className="w-full bg-primary text-white rounded-xl py-3 font-semibold hover:bg-primary/90 transition-colors"
            >
              Select This Package
            </button>
          </div>

          {/* 3 Month Package */}
          <div className="bg-gradient-to-r from-green-50 to-emerald-100 rounded-2xl p-5 border border-green-200">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center ml-3">
                  <FaGem className="text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">3-Month Package</h4>
                  <p className="text-sm text-gray-600">20% Off</p>
                </div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-green-600">240,000</div>
                <div className="text-sm text-gray-500 line-through">300,000</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="bg-white/60 rounded-xl p-3 text-center">
                <div className="text-lg font-bold text-gray-900">15</div>
                <div className="text-xs text-gray-600">Daily Alerts</div>
              </div>
              <div className="bg-white/60 rounded-xl p-3 text-center">
                <div className="text-lg font-bold text-gray-900">450</div>
                <div className="text-xs text-gray-600">Monthly Alerts</div>
              </div>
            </div>
            <button 
              onClick={() => handlePackageSelect('3-month')}
              className="w-full bg-green-600 text-white rounded-xl py-3 font-semibold hover:bg-green-700 transition-colors"
            >
              Select This Package
            </button>
          </div>

          {/* 6 Month Package */}
          <div className="bg-gradient-to-r from-purple-50 to-violet-100 rounded-2xl p-5 border border-purple-200">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-purple-600 rounded-xl flex items-center justify-center ml-3">
                  <FaStar className="text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">6-Month Package</h4>
                  <p className="text-sm text-gray-600">30% Off</p>
                </div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-purple-600">420,000</div>
                <div className="text-sm text-gray-500 line-through">600,000</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="bg-white/60 rounded-xl p-3 text-center">
                <div className="text-lg font-bold text-gray-900">20</div>
                <div className="text-xs text-gray-600">Daily Alerts</div>
              </div>
              <div className="bg-white/60 rounded-xl p-3 text-center">
                <div className="text-lg font-bold text-gray-900">600</div>
                <div className="text-xs text-gray-600">Monthly Alerts</div>
              </div>
            </div>
            <button 
              onClick={() => handlePackageSelect('6-month')}
              className="w-full bg-purple-600 text-white rounded-xl py-3 font-semibold hover:bg-purple-700 transition-colors"
            >
              Select This Package
            </button>
          </div>

          {/* 12 Month Package */}
          <div className="bg-gradient-to-r from-yellow-50 to-orange-100 rounded-2xl p-5 border border-yellow-200 relative overflow-hidden">
            <div className="absolute top-2 right-2 bg-red-500 text-white text-xs px-2 py-1 rounded-full">
              Special Offer
            </div>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-yellow-600 rounded-xl flex items-center justify-center ml-3">
                  <FaTrophy className="text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">12-Month Package</h4>
                  <p className="text-sm text-gray-600">50% Off</p>
                </div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-yellow-600">600,000</div>
                <div className="text-sm text-gray-500 line-through">1,200,000</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="bg-white/60 rounded-xl p-3 text-center">
                <div className="text-lg font-bold text-gray-900">30</div>
                <div className="text-xs text-gray-600">Daily Alerts</div>
              </div>
              <div className="bg-white/60 rounded-xl p-3 text-center">
                <div className="text-lg font-bold text-gray-900">900</div>
                <div className="text-xs text-gray-600">Monthly Alerts</div>
              </div>
            </div>
            <button 
              onClick={() => handlePackageSelect('12-month')}
              className="w-full bg-yellow-600 text-white rounded-xl py-3 font-semibold hover:bg-yellow-700 transition-colors"
            >
              Select This Package
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenewSubscription;